import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {
  backgroundGray,
  black,
  darkBlue,
  ipadproMax,
  iphone5Max,
  marketingMobileCuttoff,
  blue
} from "@css/constants";
import {FontNormal} from "@css/fonts";
import {fontSize} from "@css/styles";

export const BreadcrumbSectionContainer = styled('div')(css`
  display: flex;
  height: 70px;
  background: ${backgroundGray};
  align-items: center;
`)

export const BreadcrumSectionRow = styled('div')(css`
  display: flex;
  flex-direction: row;
  margin: 0 auto;
  max-width: 1000px;
  width: 90%;

  @media(min-width: ${marketingMobileCuttoff}) and (max-width: ${ipadproMax}) {
    width: 96%;
  }
`)

export const BreadcrumSectionDesktopRow = styled(BreadcrumSectionRow)(css`

  @media(max-width: ${marketingMobileCuttoff}) {
    display: none;
  }

`)

export const BreadcrumSectionMobileRow = styled(BreadcrumSectionRow)(css`
  display: none;

  @media(min-width: ${iphone5Max}) and (max-width: 330px) {
    width: 92%;
  }

  @media(max-width: ${marketingMobileCuttoff}) {
    display: flex;
  }
`)

export const BreadcrumbLink = styled('a')(css`
  ${FontNormal(400)}
  ${fontSize(16)};
  text-decoration-line: underline;
  color: ${blue};
  margin-right: 10px;
`);

export const BreadcrumbMobileLink = styled('a')(css`
  ${FontNormal(600)}
  ${fontSize(16)};
  color: ${darkBlue};
  display: flex;
  align-items: center;
  text-align: center;
  text-decoration: unset;
  margin-right: 0;
`);

export const BreadcrumbSpan = styled('span')(css`
  ${FontNormal(400)}
  ${fontSize(16)};
  color: ${black};
  margin-right: 10px;
`)

export const BreadcrumLinkSpan = styled('span')(css`
  margin-left: 20px;
`)

export const IconWrapper = styled('div')(css`
  position: absolute;
  padding-top: 3px;
`);
